<template>
    <div>
        <app-header></app-header>
        <div class="bg--img bg--brands-that-trust-us wash heavy">
            <h1 class="text-center pad-top--xl pad-bottom--xl z-up text-white">
                Delivery and Returns
            </h1>
        </div>
        <div class="grid-x grid-padding-x pad-top--large">
            <div class="cell small-12 medium-8 medium-offset-2">
                <h2>Free Delivery</h2>
                <p>
                    We offer free delivery across mainland UK for:
                </p>
                <ul>
                    <li>Orders of £99 (ex. VAT) and over - FREE Economy Delivery (5 Working Days | Estimated)</li>
                    <li>Orders of under £99 (ex. VAT) - £5.00 (10 Working Days | Estimated)</li>
                    <li>Express (3 Working Days | Guaranteed) - £5.00 + £1.99 per unit for Upgraded Production Status</li>
                </ul>
                <p>*Delivery dates are subject to timely approval of artwork.</p>
                <p>Delivery to Non-Mainland UK, Remote UK Areas and BFPO Addresses</p>
                <p>Please get in contact to discuss this with one of our friendly team</p>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12 medium-8 medium-offset-2">
                <h2>Express Delivery</h2>
                <p>Next Day and Express dispatch are available on selected orders (at additional cost). Please get in contact with us to discuss this</p>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12 medium-8 medium-offset-2">
                <h2>European Delivery</h2>
                <h4>European delivery destinations</h4>
                <p>As well as UK deliveries, we can also deliver to a wide range of European countries. The full list is as follows:</p>
                <p>Austria, Belgium, Bulgaria, Croatia, Czech Republic, Denmark, Estonia, Finland, France, Germany, Gibraltar, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Norway, Poland, Portugal, Romania, Slovakia, Slovenia, Spain, Sweden, Ukraine.</p>
                <h4>European delivery charges</h4>
                <p>Will be quoted on an order by order basis by our friendly Customer Service Team</p>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12 medium-8 medium-offset-2">
                <h2>After Dispatch</h2>
                <h4>Your DeliveryM</h4>
                <p>Deliveries are made from Monday to Friday between 8am and 6pm. There are no deliveries at weekends or on public holidays.</p>
                <p>We will notify you by e-mail when your order is dispatched.</p>
                <p>UK orders are dispatched by Parcelforce</p>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12 medium-8 medium-offset-2">
                <h2>Returns and Cancellations</h2>
                <h4>Cancelling an order:</h4>
                <p>We always try to deliver as quickly as possible. As a result, many orders will be dispatched within a very short space of time. Our team works around the clock to ensure orders are being dealt with the utmost importance. This means that unfortunately it is not always possible to cancel your order.</p>
                <p>Expenses are incurred at the point of order with us including artwork production, ordering of materials, and placement of orders with vendors which are subject to their cancellation or restocking policies and charges. If an order is cancelled once placed, Customised Clothing reserves the right to charge for artwork fees, restocking costs and any other expenses incurred by us between the time we received your payment and the cancellation request was received.</p>
                <h4>Returns</h4>
                <p>No one is perfect but we do aim to deliver every single order on-time, in perfect condition, every time. If we are unable to do so we aim to swiftly resolve any issue by either replacing the order, offering a refund or account credit. For bulk orders we do always recommend buying a sample first to ensure that you are completely happy with the end product. As we provide personalised goods, however, we cannot accept returns unless we have made a mistake or the garments are faulty. Please return any faulty goods to us within 14 days of receipt for investigation. Please be aware The Distance Selling Regulations Act of 2000 does not apply to &quot;personalised goods or goods made to a consumer&#39;s specification&quot;.</p>
                <p>Before placing your order, please be careful to check product size information. As we supply garments from different manufacturers who produce garments in different factories across the entire world there is no such thing as a standard size, for example a medium produced by American Apparel may differ to a medium by Gildan. On every product there is accurate sizing information for that item under the ‘Sizing information’ tab, just to the right of the product description.</p> 
                <p>Once a garment is personalised we can only accept returns based on sizing issues if the product does not measure what we have defined it to measure in the relevant size guide. If you find yourself in this position, please contact us and our customer service team will be happy to help.</p>
                <p>Blank products can be returned to us within 14 days of delivery for a refund of the cost of the item. Please contact customer services with your order number if you would like to return blank items and they will provide further instructions.</p>
            </div>
        </div>
        <div class="bg--img wash heavy bg--home-stats">
            <div class="grid-x grid-padding-x z-up pad-top pad-bottom">
                <div class="cell small-12 medium-4">
                    <p class="text-center">
                        <img src="../../../static/images/product-number.png" alt="" />
                    </p>
                    <p class="text-white text-center">Number of products</p>
                    <h4 class="text-white text-center">4,455</h4>
                </div>
                <div class="cell small-12 medium-4">
                    <p class="text-center">
                        <img src="../../../static/images/customisation-number.png" alt="" />
                    </p>
                    <p class="text-white text-center">Number of customisations to date</p>
                    <h4 class="text-white text-center">23,443</h4>
                </div>
                <div class="cell small-12 medium-4">
                    <p class="text-center">
                        <img src="../../../static/images/satisfaction-number.png" alt="" />
                    </p>
                    <p class="text-white text-center">Satisfaction rate</p>
                    <h4 class="text-white text-center">96%</h4>
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12">
                <h5 class="text-center text-blue pad-top--xl pad-bottom--small">What customers say</h5>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-bottom--xl">
            <div class="cell small-12 medium-6">
                <p class="text-center">
                    <img src="../../../static/images/feedback-1.png" alt="" />
                </p>
                <h5 class="text-center">
                    Albert Parker / London
                </h5>
                <p class="text-center pad-left pad-right">
                    The Customised Clothing website was very easy to use, I placed my order online
                    and actually received it a day earlier than expected. Great quality clothing
                    and service! I would highly recommend.
                </p>
                <p class="text-center">
                    <img src="../../../static/images/stars.png" alt="" />
                </p>
            </div>
            <div class="cell small-12 medium-6">
                <p class="text-center">
                    <img src="../../../static/images/feedback-2.png" alt="" />
                </p>
                <h5 class="text-center">
                    Tom Pollas / Germany
                </h5>
                <p class="text-center pad-left pad-right">
                    I had an urgent requirement for some printed t-shirts for an event, Customised
                    Clothing delivered the t-shirts on time and the quality of print was fantastic.
                    I will definitely be ordering from them again.
                </p>
                <p class="text-center">
                    <img src="../../../static/images/stars.png" alt="" />
                </p>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

export default {
    name: 'Delivery',
    metaInfo() {
        return {
            title: 'Delivery',
            titleTemplate: '%s-CustomisedClothing',
            meta: [
                { description: 'Delivery' },
            ],
            link: [
                { rel: 'canonical', href: 'https://customisedclothing.com/delivery' },
            ],
        };
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/StaticPages/Delivery.vue